import UserSessionStateService from '@/services/UserSessionStateService';


export const userSessionStateStore = {
  namespaced: true,
  state: {
    userSessionState: {
      user: null,
      corporation: null,
      company: null,
      selectableCorporations: [],
      featurePermissions: {},
    },
  },
  mutations: {
    SET(state, userSessionState) {
      state.userSessionState = userSessionState;
    },
  },
  getters:{
    selectableCompanies: state =>{
      if (!state.userSessionState.corporation){
        return [];
      }
      return state.userSessionState.corporation.companies;
    },
    selectableCorporations: state => {
      return state.userSessionState.selectableCorporations;
    },
    corporation: state => {
      return state.userSessionState.corporation;
    },
    company: state => {
      return state.userSessionState.company;
    },

    user: state => {
      return state.userSessionState.user;
    },

    featurePermissions: state => {
      return state.userSessionState.featurePermissions;
    },
  },
  actions: {
    update: (context) =>{
      UserSessionStateService.getState().then(result =>{
        context.commit('SET',result.data);
      });
    },
  },
};
